/**
 * 小程序 web-view 内 H5 与原生页通信
 *
 * - 登录过期 / 退出：reLaunch index，由原生 login 后带 openid+token 打开 H5
 * - 切换企业：reLaunch bind?rebind=1，由绑定页用本地凭证解绑后重绑
 * - 公众号：navigateTo official 中转页
 */
const WX_SDK_URL = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
const MP_REAUTH_PATH = '/pages/index/index'
const MP_BIND_PATH = '/pages/bind/bind?rebind=1'
const MP_OFFICIAL_PATH = '/pages/official/official'
const REDIRECT_STORAGE_KEY = 'h5_mp_login_redirect'

let sdkLoading = null

function loadWeixinSdk() {
  if (typeof window === 'undefined') return Promise.resolve(false)
  if (window.wx && window.wx.miniProgram) return Promise.resolve(true)
  if (sdkLoading) return sdkLoading

  sdkLoading = new Promise(function (resolve) {
    const existed = document.querySelector('script[data-h5-mp-sdk="jweixin"]')
    if (existed) {
      existed.addEventListener('load', function () {
        resolve(Boolean(window.wx && window.wx.miniProgram))
      })
      existed.addEventListener('error', function () {
        resolve(false)
      })
      return
    }

    const script = document.createElement('script')
    script.src = WX_SDK_URL
    script.async = true
    script.setAttribute('data-h5-mp-sdk', 'jweixin')
    script.onload = function () {
      resolve(Boolean(window.wx && window.wx.miniProgram))
    }
    script.onerror = function () {
      resolve(false)
    }
    document.head.appendChild(script)
  })

  return sdkLoading
}

async function mpReLaunch(url) {
  const sdkReady = await loadWeixinSdk()
  if (!sdkReady || !window.wx || !window.wx.miniProgram) {
    return false
  }
  return new Promise(function (resolve) {
    window.wx.miniProgram.reLaunch({
      url: url,
      success: function () {
        resolve(true)
      },
      fail: function () {
        resolve(false)
      }
    })
  })
}

async function mpNavigateTo(url) {
  const sdkReady = await loadWeixinSdk()
  if (!sdkReady || !window.wx || !window.wx.miniProgram) {
    return false
  }
  return new Promise(function (resolve) {
    window.wx.miniProgram.navigateTo({
      url: url,
      success: function () {
        resolve(true)
      },
      fail: function () {
        resolve(false)
      }
    })
  })
}

function saveH5LoginRedirect(redirect) {
  if (!redirect || typeof redirect !== 'string') return
  try {
    sessionStorage.setItem(REDIRECT_STORAGE_KEY, redirect)
  } catch (e) {
    // ignore
  }
}

export function consumeH5LoginRedirect() {
  try {
    const redirect = sessionStorage.getItem(REDIRECT_STORAGE_KEY) || ''
    sessionStorage.removeItem(REDIRECT_STORAGE_KEY)
    return redirect
  } catch (e) {
    return ''
  }
}

/** 回到小程序 index：重新 login 并打开 H5（业务过期确认后 / 退出 / 短期凭证失效） */
export async function redirectToMpReauth(options = {}) {
  const { redirect = '' } = options
  if (redirect) saveH5LoginRedirect(redirect)
  return mpReLaunch(MP_REAUTH_PATH)
}

/** 切换企业：进绑定页（rebind=1，由小程序侧解绑） */
export async function redirectToMpBind() {
  return mpReLaunch(MP_BIND_PATH)
}

/** H5 → 小程序中转页 → 打开同主体/关联公众号 */
export async function navigateToMpOfficialAccount() {
  return mpNavigateTo(MP_OFFICIAL_PATH)
}
